import {
  getAirQualityCategoryLabel,
  getAirQualityCategoryColor,
  getAirQualityCategoryMeterImage,
  unknownAirQualityCategory,
} from 'features/Weather/features/Forecast/features/AirQuality/config/airQuality.config';
import { PiWavesBold } from 'react-icons/pi';

const AirQualityMeter = ({ report }) => {
  const concentration = report?.concentration ?? '--';
  const category = report?.category ?? unknownAirQualityCategory;
  const categoryLabel = getAirQualityCategoryLabel(category);
  const categoryColor = getAirQualityCategoryColor(category) || 'var(--color-secondary, #9fb0c2)';

  return (
    <figure
      className="air-quality-meter-panel d-flex flex-column align-items-center h-100 mb-0"
      style={{ '--air-quality-category-color': categoryColor }}
    >
      <div className="air-quality-meter-image-frame">
        <img
          className="air-quality-meter air-quality-meter-image"
          src={getAirQualityCategoryMeterImage(category)}
          alt=""
        />
      </div>
      <figcaption className="air-quality-meter-caption d-flex flex-column align-items-center justify-content-center">
        <div className="air-quality-meter-status">
          <span className="air-quality-meter-status-icon">
            <PiWavesBold aria-hidden />
          </span>
          <span className="air-quality-meter-status-label">{categoryLabel}</span>
        </div>
        <div className="air-quality-meter-reading">
          <span className="air-quality-meter-reading-label">Concentration</span>
          <span className="air-quality-meter-reading-value">{concentration} ppb</span>
        </div>
        {report?.description && (
          <p className="air-quality-meter-description mb-0">{report.description}</p>
        )}
      </figcaption>
    </figure>
  );
};

export default AirQualityMeter;
